@if (loading) {
  <div class="flex items-center justify-center gap-3 py-12 text-sm text-neutral-500 dark:text-neutral-400">
    <svg class="h-5 w-5 animate-spin" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" fill="none" />
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
    </svg>
    Carregando detalhes...
  </div>
} @else if (error) {
  <app-alert type="danger" icon="x-circle">
    {{ error }}
  </app-alert>
} @else if (events().length > 0) {
  <!-- Header + Search -->
  <div class="flex items-center justify-between gap-4 mb-4 px-1">
    <div class="flex items-center gap-2">
      <svg class="h-4 w-4 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span class="text-xs font-semibold uppercase tracking-wider text-neutral-500 dark:text-neutral-400">
        {{ filteredEvents().length }} de {{ events().length }} eventos
      </span>
    </div>

    <!-- Search input -->
    <div class="relative">
      <svg class="absolute left-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-neutral-400 dark:text-neutral-500 pointer-events-none" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
      <input
        type="text"
        placeholder="Buscar eventos..."
        [ngModel]="searchTerm()"
        (ngModelChange)="onSearchInput($event)"
        class="w-56 rounded-lg border border-neutral-200 bg-white py-1.5 pl-8 pr-3
               text-xs text-neutral-700 placeholder-neutral-400
               focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20
               dark:border-neutral-600 dark:bg-neutral-800 dark:text-neutral-200
               dark:placeholder-neutral-500 dark:focus:border-blue-500"
      />
    </div>
  </div>

  <!-- Timeline list -->
  <div class="max-h-[60vh] overflow-y-auto pr-1">
    @if (filteredEvents().length === 0) {
      <div class="flex flex-col items-center justify-center py-8 text-neutral-400 dark:text-neutral-500">
        <svg class="h-8 w-8 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
        <span class="text-sm">Nenhum evento encontrado para "{{ searchTerm() }}"</span>
      </div>
    } @else {
      <ng-container *ngFor="let event of filteredEvents(); let i = index; let first = first; let last = last">
        <app-order-full-timeline-item
          [event]="event"
          [isFirst]="first"
          [isLast]="last"
        />
      </ng-container>
    }
  </div>
} @else {
  <div class="flex flex-col items-center justify-center py-12 text-neutral-400 dark:text-neutral-500">
    <svg class="h-10 w-10 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
      <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
    <span class="text-sm">Nenhum evento encontrado</span>
  </div>
}
